import React from 'react';
import Button from 'react-bootstrap/Button';

import Column from './base.jsx';
import { formatPortfolio } from './formatPortfolio.js';

const columnOptions = {
  id: 'col-call-to-action',
  title: 'View Portfolio Link'
};


const HeaderColumn = function() {
  return <th></th>;
}


class DetailColumn extends React.Component {
  render() {
    const standardPortfolio = formatPortfolio(this.props.row);
    const { selected, name } = this.props.row;
    return (
      <td className="text-right">
         <Button title={`view ${name} portfolio`} disabled={selected} onClick={() => this.props.row.selectPortfolio(standardPortfolio)} size="sm">
            <i className="far fa-eye"></i>
          </Button>
      </td>
    );
  }
}


class CallToAction extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default CallToAction;

